import { render, staticRenderFns } from "./feedback-form.vue?vue&type=template&id=815df49a"
import script from "./feedback-form.vue?vue&type=script&lang=js"
export * from "./feedback-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports